import React from "react";
import logo from "../../images/WhatzOn-logo.svg";

const FullWidthLayout = (props) => {
  return (
    <div className="fullwidthlayout login-section">
      <div className="fullwidth-row">
        <div className="logo">
          <img src={logo} alt="admin logo" />
        </div>
        <div className="lg-right">{props.children}</div>
      </div>
    </div>
  );
};
export default FullWidthLayout;
